import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import Icon24 from 'builder/components/Icon'
import { ButtonSize, ButtonV2 } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { actions, selectors } from 'builder/modules/resumeEditor'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useAutoTailoring } from 'builder/components/AutoTailoring/hooks/useAutoTailoring'
import { useStepByStepFlow } from '../../StepByStepFlow/hooks/useStepByStepFlow'

interface Props {
  width?: string
}
export const StartTailoringButton = ({ width }: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()

  const { isFinishStep } = useStepByStepFlow()
  const { isDataMissed } = useAutoTailoring()

  useEffect(() => {
    if (isFinishStep) {
      dispatch(actions.setAutoTailoringForPublicJobBoard({ enableAutoTailoringButton: true }))
    }
  }, [dispatch, isFinishStep])

  const handleClick = () => {
    if (isDataMissed) {
      dispatch(actions.setOpenOptimizerModal(true))
      return
    }

    dispatch(actions.autoTailorForPublicJobBoard())
    trackInternalEvent('click_start_tailoring')
  }

  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  return (
    <ButtonV2
      leadingIcon={<Icon24.ArrowTargetAutoTailoring />}
      onClick={handleClick}
      size={ButtonSize.small}
      isDisabled={!autoTailoringFromPublicJobBoard.enableAutoTailoringButton}
      style={{ width }}
    >
      {i18n.t('builder.prefill_resume.auto_tailoring_view.start_tailoring')}
    </ButtonV2>
  )
}
